module.exports = __webpack_public_path__ + "static/media/IMG_0016.42ba4cda.jpg";